import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../firebase';

export const updateUserEmailAuth = httpsCallable(functions, 'updateEmailAuth');
